export default "__VITE_ASSET__c6a4f8fb__"